import type { VirtualAppointmentStatus } from '../../services/virtualAppointments';
import { TruncatedLabel } from '../shared/TruncatedLabel';
import { VIRTUAL_APPOINTMENT_STATUS_LABELS } from '@odo/shared-ui/clinical/virtualAppointments/summary';
import { virtualAppointmentStatusBg } from './virtualAppointmentStatusColors';

interface VirtualAppointmentStatusChipProps {
    status: VirtualAppointmentStatus;
    size?: 'sm' | 'xs';
}

// Read-only twin of the status dropdown's trigger, sized like TeamPill so the two sit side by side.
export function VirtualAppointmentStatusChip({
    status,
    size = 'sm'
}: VirtualAppointmentStatusChipProps) {
    const isXs = size === 'xs';
    return (
        <span
            className={`inline-flex items-center max-w-full rounded-md font-semibold text-white whitespace-nowrap ${
                isXs ? 'text-[10px] px-2 py-0.5 gap-1' : 'text-xs px-3.5 py-1.5 gap-1.5'
            } ${virtualAppointmentStatusBg(status)}`}
        >
            <span
                aria-hidden="true"
                className={`rounded-full bg-white/40 flex-shrink-0 ${isXs ? 'w-1 h-1' : 'w-1.5 h-1.5'}`}
            />
            <TruncatedLabel text={VIRTUAL_APPOINTMENT_STATUS_LABELS[status]} className="min-w-0" />
        </span>
    );
}
